import { Small } from "@fronterahealth/frontera-ui-components";

import { ApiReportSectionFieldsFieldTypeChoices } from "@api/graphql/types-and-hooks";
import { ProposedEditDiff } from "@components/QaReview/PeerReview/ProposedEditDiff";
import { toChoiceItems, toReadableValue } from "@components/QaReview/PeerReview/peerReview.readableValue";
import { toBreakableSpaces } from "@components/QaReview/PeerReview/peerReview.wordDiff";

export const ConflictDialogBody: React.FC<{
  fieldType?: ApiReportSectionFieldsFieldTypeChoices;
  baseValue: string;
  proposedValue: string;
  currentValue: string;
}> = ({ fieldType, baseValue, proposedValue, currentValue }) => (
  <div className="space-y-3">
    <Small className="text-text-secondary">
      This field changed after the suggestion was made. Applying it now would overwrite the current text.
    </Small>
    <div>
      <Small className="mb-1 block font-medium text-text-tertiary">Proposed change</Small>
      <ProposedEditDiff fieldType={fieldType} baseValue={baseValue} proposedValue={proposedValue} />
    </div>
    <div>
      <Small className="mb-1 block font-medium text-text-tertiary">Current text in the report</Small>
      <div className="rounded-md border border-limestone-200 bg-limestone-50 px-2 py-1 text-xs whitespace-pre-wrap">
        {toBreakableSpaces(
          toChoiceItems(fieldType, currentValue)?.join("\n") ?? toReadableValue(fieldType, currentValue),
        ) || "(empty)"}
      </div>
    </div>
  </div>
);
